/**
 * Get the URL parameter value by name
 * @param {string} name - The name of the parameter.
 * @param {string} [search] - Custom params (optional).
 * @returns {string}
 */
const getQueryParam = (name, search) => {
    const params = new URLSearchParams(search || window.location.search);
    const result = params.get(name);
    return result ? decodeURIComponent(result) : result;
};
export default getQueryParam;
